var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurniture1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.569,
    height: 44.512,
    viewBox: "0 0 47.569 44.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7749",
    "data-name": "Grupo 7749",
    transform: "translate(-54 -54.457)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2106",
    "data-name": "Ret\\xE2ngulo 2106",
    width: 40,
    height: 8,
    rx: 4,
    transform: "translate(58 62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7748",
    "data-name": "Grupo 7748"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2107",
    "data-name": "Ret\\xE2ngulo 2107",
    width: 40,
    height: 12,
    rx: 4,
    transform: "translate(58 75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_27",
    "data-name": "Uni\\xE3o 27",
    d: "M39.179,44.512a2.8,2.8,0,0,1-2.794-2.794V38.328h-25.2v3.389A2.8,2.8,0,0,1,8.39,44.512H6.5A2.8,2.8,0,0,1,3.7,41.718V38.328H2.782A2.791,2.791,0,0,1,0,35.535V2.794A2.791,2.791,0,0,1,2.782,0H44.775a2.8,2.8,0,0,1,2.794,2.794V35.535a2.8,2.8,0,0,1-2.794,2.794h-.921v3.389a2.791,2.791,0,0,1-2.783,2.794Zm-.991-2.794a.992.992,0,0,0,.991.992h1.893a.975.975,0,0,0,.98-.992V38.328H38.188Zm-32.682,0a.992.992,0,0,0,.991.992H8.39a.993.993,0,0,0,.992-.992V38.328H5.506ZM1.8,2.794V35.535a.987.987,0,0,0,.979.991H44.775a.993.993,0,0,0,.992-.991V2.794a.992.992,0,0,0-.992-.991H2.782A.986.986,0,0,0,1.8,2.794ZM6.239,32.215A2.116,2.116,0,0,1,4.126,30.1V22.568a2.115,2.115,0,0,1,2.113-2.113H41.331a2.108,2.108,0,0,1,2.1,2.112V30.1h0q0,.027,0,.054a2.108,2.108,0,0,1-2.1,2.059ZM5.929,30.1a.307.307,0,0,0,.31.311H41.331a.29.29,0,0,0,.246-.131.325.325,0,0,0,.051-.178V22.568a.3.3,0,0,0-.236-.3.309.309,0,0,0-.061-.006H6.239a.306.306,0,0,0-.31.311Zm14.563-2.866a.9.9,0,1,1,0-1.8h6.581a.9.9,0,0,1,0,1.8ZM6.239,17.873a2.116,2.116,0,0,1-2.113-2.112V8.225a2.116,2.116,0,0,1,2-2.11l.109,0H41.331l.108,0a2.109,2.109,0,0,1,1.992,2.11V15.76h0q0,.027,0,.054a2.108,2.108,0,0,1-2.1,2.058Zm0-1.8H41.331a.291.291,0,0,0,.212-.089.316.316,0,0,0,.085-.221V8.225a.3.3,0,0,0-.281-.31H6.207a.306.306,0,0,0-.277.309V15.76a.307.307,0,0,0,.31.311Z",
    transform: "translate(54 54.457)",
    fill: "#153c8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7570",
    "data-name": "Grupo 7570",
    transform: "translate(73.59 65.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8639",
    "data-name": "Caminho 8639",
    d: "M128.962,18.186h-6.581a.9.9,0,0,1,0-1.8h6.581a.9.9,0,0,1,0,1.8Z",
    transform: "translate(-121.48 -16.383)",
    fill: "#153c8b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture1);
export default __webpack_public_path__ + "static/media/furniture-1.a5ffadfdc0b247ba723c3bebddb212aa.svg";
export { ForwardRef as ReactComponent };